import React, { Fragment } from 'react';
import SimpleImageSlider from 'react-simple-image-slider';

function SliderImage() {
  const images = [
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner1.jpeg?alt=media&token=e439ba0b-71a3-4199-94bc-1f68cafbf5f4',
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner2.jpeg?alt=media&token=da6c9d3b-c2fb-4d52-91d2-8ec21097b2b9',
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner3.jpeg?alt=media&token=fff5c2d1-8a0d-4764-8f2f-b3444ab11e3d',
    },
  ];

  const sliderMobile = [
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner4.jpeg?alt=media&token=f6fda23d-c5c9-4896-8904-e73712af0286',
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner5.jpeg?alt=media&token=36843222-f2d0-4008-b670-67b0f3bd3b22',
    },
    {
      url: 'https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/banner6.jpeg?alt=media&token=b31b9d11-4dbb-4046-822e-959bffec4c33',
    },
  ];

  return (
    <Fragment>
      <div
        className={`h-132 w-full sm:hidden md:block shadow-lg shadow-gray300 bg-white mt-16 `}
      >
        <SimpleImageSlider
          width={'100%'}
          height={'40rem'}
          images={images}
          autoPlay={1.5}
          slideDuration={0.7}
          showBullets={true}
          loop
        />
      </div>

      <div
        className={`h-128 w-full md:hidden shadow-lg shadow-gray800 bg-white`}
      >
        <SimpleImageSlider
          width={'100%'}
          height={'32rem'}
          images={sliderMobile}
          autoPlay={1.5}
          slideDuration={0.7}
          showBullets={true}
          loop
        />
      </div>
    </Fragment>
  );
}

export default SliderImage;
